import {AuthoritiesMap} from "@context/appContext/types/appContext";

export const getUserAccessByKeys = ({
                                  keys,
                                  authorities,
                                  accessType = 'strict',
                              }: {
    keys: string | string[],
    accessType?: 'strict' | 'or',
    authorities: AuthoritiesMap
}): boolean => {

    if(!keys){
        return  false
    }

    const getAccessByKey = (key:string)=>{
        if (!authorities || !(key in authorities)) {
            return false
        }
        return authorities[key]
    }

    if (typeof keys === 'string') {
        return  getAccessByKey(keys)
    }

    if (Array.isArray(keys)) {
        if(!keys?.length){
            return  false
        }
        if (accessType === 'strict'){
            let access = true
            keys.forEach((key)=>{
                const currentAccess = getAccessByKey(key)
                if(!currentAccess){
                    access = false
                }
            })
            return  access
        }
        if(accessType === 'or'){
            let access = false
            keys.forEach((key)=>{
                const currentAccess = getAccessByKey(key)

                if(currentAccess){
                    access = true
                }
            })
            return  access
        }

    }
    return false
}